import { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { trackEvent } from '@services/tracking/service';
import { trackOpenedEvent } from '@services/tracking/service/trackOpenedEvent';
import type { TrackingEventName } from '@services/tracking/events';

// track an event when the screen is focused (legacy - prefer useTrackScreenOpened, see below)
export const useTracking = (eventName: TrackingEventName | string): void => {
  useFocusEffect(
    useCallback(() => {
      trackEvent(eventName);
    }, [eventName])
  );
};

// track an "opened" event with deduplication and rich properties
// accepts static properties or a getter function evaluated at focus time
export const useTrackScreenOpened = (
  eventName: TrackingEventName | string,
  properties: Record<string, unknown> | (() => Record<string, unknown>) = {},
): void => {
  useFocusEffect(
    useCallback(() => {
      const props = typeof properties === 'function' ? properties() : properties;
      trackOpenedEvent(eventName, props);
    }, [eventName])
  );
};
